import React from 'react';
import { connect } from 'dva';

import Document, { DocumentProps } from '../../shared/Document/Document';
import { SPOUSE } from '../../../constants/modelNames';
import SpouseDocumentWarning from './SpouseDocumentWarning';

const SpouseDocument = (props: DocumentProps) => {
  return (
    <div className="Document">
      <Document {...props} />
      <SpouseDocumentWarning />
    </div>
  );
};

function mapStateToProps({ spouse: { dul, citizenship, birthPlace } }) {
  return {
    ...dul,
    citizenship: citizenship.value,
    showBirthPlace: true,
    birthPlace,
    model: SPOUSE,
  };
}

export default connect(mapStateToProps)(SpouseDocument);
